module.exports = __webpack_public_path__ + "img/Dundee_City.393ed49b.png";